import { createSelector } from 'reselect';
import { IRootState } from 'src/redux/interface';

export const modalSelector = createSelector(
    (state: IRootState) => state.auth,
    (auth) => auth,
);
export const signinSelector = createSelector(modalSelector, (auth) => auth.signin);
export const signupSelector = createSelector(modalSelector, (auth) => auth.signup);
export const forgotSelector = createSelector(modalSelector, (auth) => auth.forgot);

export const isLoginSelector = createSelector(modalSelector, ({ userInfo }) => {
    return !!userInfo.auth.accessToken && !!userInfo.auth.email;
});
export const userInfoSelector = createSelector(modalSelector, ({ userInfo }) => userInfo);
export const accessTokenSelector = createSelector(modalSelector, ({ userInfo }) => userInfo.auth.accessToken);

export const loadingSelector = createSelector(modalSelector, ({ loading }) => loading);
export const verifySelector = createSelector(modalSelector, (auth) => auth.verify);
